import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { token } from "./token.js";
function Divider({
  direction = "horizontal",
  ...props
}) {
  if (direction === "horizontal") {
    return /* @__PURE__ */ jsx(HorizontalDivider, {
      ...props
    });
  }
  return /* @__PURE__ */ jsx(VerticalDivider, {
    role: "separator",
    ...props
  });
}
const HorizontalDivider = styled.hr.withConfig({
  displayName: "HorizontalDivider",
  componentId: "sc-1dm91yn-0"
})(["box-sizing:content-box;height:1px;margin:0;padding:", " 0;border:none;background:", ";background-clip:content-box;"], token.spacing3, token.componentDividerColor);
const VerticalDivider = styled.div.withConfig({
  displayName: "VerticalDivider",
  componentId: "sc-1dm91yn-1"
})(["box-sizing:content-box;width:1px;min-height:100%;margin:0;padding:0 ", ";background:", ";background-clip:content-box;"], token.spacing2, token.componentDividerColor);
export {
  Divider,
  HorizontalDivider,
  VerticalDivider
};
//# sourceMappingURL=Divider.js.map
